import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MicroFrontendsModule } from '@xdig/ng-microkernel/micro-frontend';
import { LoadingMicroFrontends } from './loading-micro-frontends';
import { UpperCasePipe } from '@angular/common';
import { DefaultComponent } from '@core/layouts/default/default.component';
import { microFrontendsMetadata } from './app.micro-apps';
import { PageNotFoundComponent } from '@shared/errors/modal/containers/page-not-found/page-not-found.component';
import { PrivacyPoliciesComponent } from '@core/layouts/privacy-policies/privacy-policies.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultComponent,
    children: [],
  },
  {
    path: 'personas/politicas-de-privacidad',
    component: PrivacyPoliciesComponent,
  },
  {
    path: '**',
    component: DefaultComponent,
    children: [{ path: '', component: PageNotFoundComponent }],
  },
];

@NgModule({
  providers: [UpperCasePipe],
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    // TODO: URL cargado de manera dinámica por endpoint "micro-frontends.json".
    MicroFrontendsModule.addRoutesInShell({
      microFrontendsLifecycle: LoadingMicroFrontends,
      microFrontendsMetadata,
    }),
  ],
  exports: [RouterModule, MicroFrontendsModule],
})
export class AppRoutingModule {}
